import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-07cfd9c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "career_listing__wrapper" };
const _hoisted_2 = {
    key: 0,
    class: "module bottom_spacing-25"
};
const _hoisted_3 = { class: "career_listing" };
const _hoisted_4 = { class: "career_listing__single--container" };
const _hoisted_5 = ["href", "title"];
const _hoisted_6 = { class: "career_listing__content flex items-center" };
const _hoisted_7 = {
    key: 0,
    class: "flex-grow"
};
export default /*#__PURE__*/ _defineComponent({
    __name: 'career_listing',
    props: ['d'],
    setup(__props) {
        const props = __props;
        function getMainTextBlockData() {
            return {
                background_colour: '#fff',
                line_one: props.d.title ? '<span>' + props.d.title + '</span>' : '',
                line_two: '',
                leadin: props.d.leadin,
                show_arrow: 'false',
            };
        }
        return (_ctx, _cache) => {
            const _component_main_text_block = _resolveComponent("main-text-block");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.d.title)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_main_text_block, {
                            d: getMainTextBlockData()
                        }, null, 8, ["d"])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.careers, (listing, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["career_listing__single", { 'grey-background': Number(index) % 2 === 0, 'white-background': Number(index) % 2 !== 0 }]),
                                key: index
                            }, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("a", {
                                        href: listing.alias ?? '#ignite-application',
                                        title: listing.alias ? 'Click to view ' + listing.title.toLowerCase() : null,
                                        class: "career_listing__link"
                                    }, [
                                        _createElementVNode("div", _hoisted_6, [
                                            (listing.title)
                                                ? (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(listing.title), 1))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("img", {
                                                ref_for: true,
                                                ref: "arrow",
                                                class: "arrow",
                                                src: "/images/right-arrow-orange.svg",
                                                loading: "lazy",
                                                alt: "arrow"
                                            }, null, 512)
                                        ])
                                    ], 8, _hoisted_5)
                                ])
                            ], 2));
                        }), 128))
                    ])
                ])
            ]));
        };
    }
});
